// extracted by mini-css-extract-plugin
export var boxItems = "_7n-1";
export var boxItemsLg = "_7n-2";
export var button = "_7n-7";
export var buttonHoverless = "_7n-9";
export var buttonLg = "_7n-8";
export var filterGroupBox = "_7n-0";
export var icon = "_7n-3";
export var iconSecondary = "_7n-6";
export var iconWrapper = "_7n-4";
export var iconWrapperLg = "_7n-5";
export var truncatedLabel = "_7n-a";